// Lib
import { classicFormat } from '@/utils/hooks/format/useFormatNumber';

import { SIZE_FULL } from '@/lib/gridElements/size';

// Components
import MediaLifeSpan from '@/components/composite/Charts/composed/MediaLifeSpan';

export const mediaLifeSpanConfig = {
    margin: { left: -30, bottom: 15 },
    minWidth: 650,
    name: {
        time: 'time',
        value: 'current_post',
        previous_value: 'previous_post'
    },
    id: 'media_life_span',
    timeFormatter: (time) => time.replace(':', 'h'),
    valueFormat: classicFormat,
    color: {
        value: 'red',
        previous_value: 'gray'
    },
    tooltip: 'chart.instagram.media_life_span_tooltip',
    size: SIZE_FULL,
    type: 'chart',
    defaultFilter: 'likes',
    filters: {
        likes: {
            title: 'chart.instagram.media_life_span_likes',
            menu: 'chart.instagram.media_life_span_show_likes'
        },
        comments: {
            title: 'chart.instagram.media_life_span_comments',
            menu: 'chart.instagram.media_life_span_show_comments'
        }
    },
    tooltipTranslation: {
        token: 'chart.instagram.media_life_span_tooltip_chart',
        values: ['time', 'value', 'previous_value']
    },
    element: MediaLifeSpan
};
